import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LMUrlUtilService } from '@services/utils';
import { LMFormRequest } from '@form/index';
import { FormRequestType } from '@app/utils';
import { Observable } from 'rxjs';

@Injectable()
export class LMBusclassFieldService {
  constructor(
    private http: HttpClient,
    private lmUrlUtilService: LMUrlUtilService
  ) {}

  public makeRequest(
    busClass: string,
    lpl: string,
    isBusinessClassCompute: boolean,
    isBusClassTotal: boolean,
    computeType = ''
  ): Observable<LMLplValidationResponse> {
    const formRequest: LMFormRequest = {
      requestType: isBusClassTotal
        ? FormRequestType.CubeRelValidateLPL
        : FormRequestType.ValidateCondition,
      param1: busClass,
      param2: lpl,
      isBusinessClassCompute,
      computeType,
    };

    const lplValidationUrl = this.buildRequestUrl(busClass);
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json;charset=utf-8');

    return this.http.post<LMLplValidationResponse>(lplValidationUrl, formRequest, { headers });
  }

  private buildRequestUrl(businessClass: string): string {
    const baseUrl = this.lmUrlUtilService.getBaseUrl();
    let url = `${baseUrl}/form/${businessClass}`;
    url = this.lmUrlUtilService.propagateSessionKeys(url, '?');
    return url;
  }
}
